/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../components/baseclasses/guid.ts" />

module Meevo.Plugins.MarketPricing {

    export class ScheduleLocationService {

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected dataService: Meevo.Components.BaseClasses.IDataService
        ) {

        }

        public getGrandfatherInfo(elem, baseEndpoint, parentItemId, priceGroupQueueId) {
            this.busyService.start();

            let id = priceGroupQueueId || parentItemId;

            return this.dataService.getItem(baseEndpoint, id, 'Grandfather/' + elem.locationId).then((data: any) => {
                elem.membershipTypeSettings = data;

                _.each(data, (type: any) => {
                    type.membershipBenefitTemplate = {
                        displayName: type.membershipBenefitTemplateDisplayName,
                        id: type.membershipBenefitTemplateId,
                    };

                    _.each(type.membershipTypeSnapshotPoints, (snapshot: any) => {
                        snapshot.membershipBenefitTemplate = {
                            displayName: snapshot.membershipBenefitTemplateDisplayName,
                            id: snapshot.membershipBenefitTemplateId,
                        }
                    });
                });

                this.busyService.stop();
                return elem;
            });
        }

        public prepareGrandfatherModel(model) {
            let elem = {
                priceGroupId: model.priceGroupId,
                scheduleDate: model.scheduleDate,
                priceGroupQueueId: model.priceGroupQueueId,
                isRemoveGrandfathering: model.isRemoveGrandfathering,
                businessTypeId: model.businessTypeId,
                membershipTypeSettings: [],
                completedLocations: [],
                membershipTypeSnapshotPoints: []
            };

            _.each(model.locationsToTransfer, (location: any) => {

                elem.completedLocations.push({
                    item1: location.locationId,
                    item2: location.isComplete
                });

                _.each(location.membershipTypeSettings, (el: any) => {
                    el.locationId = location.locationId;

                    _.each(el.membershipTypeSnapshotPoints, (snapShot: any) => {
                        snapShot.locationId = location.locationId;
                        snapShot.id = snapShot.membershipTypeSnapshotPointId;

                        elem.membershipTypeSnapshotPoints.push(snapShot);
                    });
                    delete el.membershipTypeSnapshotPoints;

                    el.id = el.membershipTypeId;
                    el.membershipPricing = el.membershipPricing ? el.membershipPricing : false;
                    el.benefitTemplatePricing = el.benefitTemplatePricing ? el.benefitTemplatePricing : false;

                    elem.membershipTypeSettings.push(el);
                });
            });

            return elem;
        }

        static factory(): Function {
            let svc = (appSettings: Meevo.Components.Common.IAppSettings,
                       identityService: Meevo.Components.Common.IIdentityService,
                       busyService: Meevo.Components.Busy.IBusyService,
                       dataService: Meevo.Components.BaseClasses.IDataService) => {
                return new ScheduleLocationService(appSettings, identityService, busyService, dataService);
            };

            svc.$inject = [
                'meevo.AppSettings',
                'meevo.components.common.IdentityService',
                'meevo.components.busy.BusyService',
                'meevo.components.common.DataService'
            ];
            return svc;
        }
    }

    angular.module("meevo.plugins.marketPricing")
        .factory("meevo.plugins.marketPricing.scheduleLocationService", ScheduleLocationService.factory());

}